
/* Close Dawn's native mobile menu before following an on-page Studio link. */
(() => {
  document.addEventListener('click', (event) => {
    if (!(event.target instanceof Element)) return;
    const link = event.target.closest('a.hm-nav-link');
    if (!link || event.button > 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const drawer = link.closest('header-drawer');
    if (!drawer || typeof drawer.closeMenuDrawer !== 'function') return;
    const summary = drawer.querySelector('summary');
    if (!summary) return;
    drawer.closeMenuDrawer(event, summary);
    summary.setAttribute('aria-expanded', 'false');
  });
})();
